import { APICore } from "./apiCore";

const api = new APICore()

function getMantenimientos(params:any): any{
    const baseUrl = "/mantenimientos"
    return api.get(baseUrl,params)
}

function getMantenimiento(id:String): any{
    const baseUrl = `/mantenimientos/${id}`
    return api.get(baseUrl,{})
}

function getInvoicesByClient(id:String):any{
    const baseUrl = `/invoices/${id}`
    return api.get(baseUrl,{})
}
function getEstimatesByClient(id:String):any{
    const baseUrl = `/estimates/${id}`
    return api.get(baseUrl,{})
}

function createEstimate(params:any):any{
    const baseUrl = "/estimates"
    return api.create(baseUrl,params)
}

function addMantenimiento(params:any): any{
    // console.log("ADDMANT ",params)
    const baseUrl = "/mantenimientos"
    return api.create(baseUrl,params)
}

function updateMantenimiento(params:any): any{
    const baseUrl = "/mantenimientos"
    return api.update(baseUrl,params)
}

function deleteMantenimiento(params:any): any{
    // console.log(params)
    const baseUrl = "/mantenimientos"
    return api.delete(baseUrl,params)
}

export {getMantenimientos,getMantenimiento,getInvoicesByClient,addMantenimiento,updateMantenimiento,deleteMantenimiento,createEstimate,getEstimatesByClient}
